<template>
  <div class="main-wrapper">
    <sidebar-menu
      width="300px"
      widthCollapsed="50px"
      :menu="menu"
      :relative="true"
      :collapsed="collapsed"
      @update:collapsed="updateCollapsed($event)"
      class="side-menu"
    >
      <template #toggle-icon>
        <v-tooltip location="end" text="開く / 閉じる">
          <template v-slot:activator="{ props }">
            <v-icon v-bind="props" icon="$mdiFormatAlignJustify"></v-icon>
          </template>
        </v-tooltip>
      </template>
    </sidebar-menu>
    <div class="main-container">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type {
  SidebarComponentItem,
  SidebarHeaderItem,
  SidebarItem,
} from "vue-sidebar-menu";
import { useSideMenu } from "@/composable/side-menu";

export default defineComponent({
  name: "NWInformationMain",
  setup() {
    const { collapsed, updateCollapsed } = useSideMenu();
    return { collapsed, updateCollapsed };
  },
  computed: {
    menu(): Array<SidebarItem | SidebarComponentItem | SidebarHeaderItem> {
      return getNWInformationMenus();
    },
  },
});

/** NW情報メニューを取得 */
export function getNWInformationMenus(): Array<SidebarItem> {
  return [
    {
      href: "/info/contract/line",
      title: "契約回線",
      icon: {
        element: "v-icon",
        attributes: { icon: "$mdiCardText" },
      },
    },
    {
      href: "/info/limit",
      title: "設定上限値",
      icon: {
        element: "v-icon",
        attributes: { icon: "$mdiFormatVerticalAlignTop" },
      },
    },
    {
      href: "/info/operation/history",
      title: "操作履歴",
      icon: { element: "v-icon", attributes: { icon: "$mdiNotebookOutline" } },
    },
    {
      href: "/info/maintenance",
      title: "障害/メンテナンス情報",
      icon: { element: "v-icon", attributes: { icon: "$mdiAlertOutline" } },
    },
    {
      href: "/info/agreement/history",
      title: "同意履歴",
      icon: {
        element: "v-icon",
        attributes: { icon: "$mdiFileDocumentCheckOutline" },
      },
    },
  ];
}
</script>
